<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col
              cols="12"
              lg="12"
            >
              <v-form ref="form_all">
                <v-tabs
                  centered
                  show-arrows
                >
                  <v-tab>
                    <v-icon left>
                      mdi-receipt
                    </v-icon>Основные
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-tune
                    </v-icon>Настройки
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-folder
                    </v-icon>Файлы
                  </v-tab>
                  <v-tab v-if="form.type === 5">
                    <v-icon left>
                      mdi-dots-grid
                    </v-icon>Планограмма
                  </v-tab>
                  <v-tab-item>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.created"
                          label="Дата создания"
                          type="date"
                          :disabled="true"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-text-field
                          v-model="form.number"
                          label="Системный номер"
                          :disabled="true"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-select
                          v-model="form.state"
                          label="Статус"
                          :items="select.state"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                      >
                        <v-select
                          v-model="form.type"
                          label="Тип устройства"
                          :items="select.type"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-text-field
                          v-model="form.model"
                          label="Модель"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-checkbox
                          v-model="form.serial_control"
                          label="Контроль серийного номера"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-checkbox
                          v-model="form.restricted"
                          label="Ограничение на добавление"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-data-table
                      :items="form.settings"
                      :headers="[
                        {value: 'main', text: ''},
                        {value: 'delete', text: '', width: 50}
                      ]"
                      :footer-props="datatable_footer"
                      no-data-text="Нет данных для отображения"
                    >
                      <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                        {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                      </template>
                      <template v-slot:item.main="{item}">
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-select
                              v-model="item.type"
                              :items="[
                                {
                                  value: 0, text: 'Строка'
                                },
                                {
                                  value: 1, text: 'Чекбокс'
                                },
                                {
                                  value: 2, text: 'Выбор'
                                },
                                {
                                  value: 3, text: 'Многострочный текст'
                                },
                                {
                                  value: 4, text: 'Файл'
                                }
                              ]"
                              label="Тип параметра"
                              @change="settings_change(item)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="8"
                          >
                            <div v-if="item.type == 2">
                              <v-row
                                v-for="(value, index) in item.values"
                                :key="'value_' + index"
                              >
                                <v-col cols="4">
                                  <v-text-field
                                    v-model="value.text"
                                    label="Значение"
                                  />
                                </v-col>
                                <v-col cols="7">
                                  <v-text-field
                                    v-model="value.value"
                                    label="Ключ"
                                  />
                                </v-col>
                                <v-col cols="1">
                                  <v-icon @click="item.values = item.values.filter(a=>a!=value)">
                                    mdi-delete
                                  </v-icon>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-icon @click="item.values.push({})">
                                  mdi-plus
                                </v-icon>
                              </v-row>
                            </div>
                          </v-col>
                          <v-col
                            cols="12"
                            md="8"
                          >
                            <v-text-field
                              v-model="item.description"
                              label="Описание"
                              @input="settings_change(item)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="item.key"
                              label="Ключ"
                              @input="settings_change(item)"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-if="item.type == 0"
                              v-model="item.default_value"
                              label="Значение по умолчанию"
                              @input="settings_change(item)"
                            />
                            <v-checkbox
                              v-if="item.type == 1"
                              v-model="item.default_value"
                              label="Значение по умолчанию"
                              @change="settings_change(item)"
                            />
                            <v-select
                              v-if="item.type == 2"
                              v-model="item.default_value"
                              :items="item.values"
                              label="Значение по умолчанию"
                              @change="settings_change(item)"
                            />
                            <v-textarea
                              v-if="item.type == 3"
                              v-model="item.default_value"
                              label="Значение по умолчанию"
                              @input="settings_change(item)"
                            />
                          </v-col>
                        </v-row>
                      </template>
                      <template v-slot:item.delete="{item}">
                        <v-icon
                          v-if="!item.new"
                          @click="form.settings = form.settings.filter(a=>a!=item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item>
                    <v-form>
                      <v-container class="py-0">
                        <v-card
                          class="elevation-1"
                          text
                        >
                          <v-progress-linear
                            class="ma-0"
                            color="secondary"
                            :indeterminate="loader.show"
                          />
                          <v-card-text>
                            <v-data-table
                              hide-default-footer
                              hide-default-header
                              :items="form.files"
                              :headers="table.headers"
                              no-data-text="Нет данных для отображения"
                            >
                              <template v-slot:item.save="{item}">
                                <v-icon @click="getDoc(item)">
                                  mdi-content-save
                                </v-icon>
                              </template>
                              <template v-slot:item.comment="{item}">
                                <v-text-field
                                  v-model="item.comment"
                                  :disabled="loader.show || view"
                                  label="Описание"
                                />
                              </template>
                            </v-data-table>
                          </v-card-text>
                          <v-card-actions class="grey lighten-4">
                            <v-btn
                              color="primary"
                              text
                              :disabled="loader.show || view"
                              @click="$refs.upload.click()"
                            >
                              Добавить файл
                            </v-btn>
                            <input
                              ref="upload"
                              type="file"
                              style="display: none;"
                              @change="upload"
                            >
                          </v-card-actions>
                        </v-card>
                      </v-container>
                    </v-form>
                  </v-tab-item>
                  <v-tab-item v-if="form.type === 5">
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-data-table
                          :items="form.planogramm"
                          :headers="[{text: 'Код ячейки', value: 'number'}, {text: 'Тип', value: 'type'}, {text: 'Емкость ячейки', value: 'amount'}, {value: 'delete', text: ''}]"
                          :footer-props="datatable_footer"
                          no-data-text="Нет данных для отображения"
                        >
                          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                          </template>
                          <template v-slot:item.number="{item}">
                            <v-text-field
                              v-model="item.number"
                              type="number"
                              label="Код ячейки"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.amount="{item}">
                            <v-text-field
                              v-model="item.amount"
                              type="number"
                              label="Емкость ячейки"
                              :disabled="item.type!=0"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.type="{item}">
                            <v-select
                              v-model="item.type"
                              label="Тип"
                              :items="[{value: 0, text: 'Товар'}, {value: 1, text: 'Рецепт'}, {value: 2, text: 'Платеж'}]"
                              @change="planogramm_change(item)"
                            />
                          </template>
                          <template v-slot:item.delete="{item}">
                            <v-icon
                              v-if="!item.new"
                              @click="form.planogramm = form.planogramm.filter(a=>a!=item)"
                            >
                              mdi-delete
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="justify-center">
            <v-col
              cols="6"
              lg="3"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Назад</span>
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              lg="3"
              class="text-right"
            >
              <v-btn
                color="primary"
                class="ml-auto"
                @click="save_device"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  import suggest from '../../../libs/suggestions.min.17.12.0.dev.js'
  export default {
    props: ['create', 'change', 'view', 'show', 'item'],
    data: () => ({
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      menu: {
        from: false,
        to: false
      },
      event: {
        items: [],
        form: {
          client: '',
        },
      },
      selected: {
      },
      info: {

      },
      loader: {
        show: false,
      },
      dialog: {
        event: {
          show: false,
          item: {},
        },

      },
      events: [

      ],
      table: {
        headers: [
          {
            text: '',
            value: 'save',
          },
          {
            text: 'Название',
            value: 'name',
          },
          {
            text: 'Описание',
            value: 'comment',
          },
        ],
      },
      tabs: [
        'Основные',
        'Настройки',
        'Файлы',
      ],
      data: {
        phone: '',
      },
      form: {
        files: [],
        settings: [
          {
            new: true,
            values: []
          }
        ],
        planogramm: [
          {
            new: true
          }
        ]
      },
      logs: [],
      dict: {
        device: {},
        insurer: {},
        phone: {
          1: 'Мобильный',
          2: 'Домашний',
        },
        address: {
          1: 'Юридический адрес',
          2: 'Фактический адрес',
        },
        file: {
          type: {
            0: 'Без типа',
            1: 'Слайдер в описании проекта',
            2: 'Договор поручительства',
            3: 'Документы проекта',
          },
        },
        event: {
          1: 'Звонок',
          2: 'SMS сообщение',
          3: 'Email сообщение',
          4: 'Встреча',
          5: 'Другое',
        },
        type: {}
      },
      select: {
        type: [
        ],
        state: [
          { value: 0, text: 'Доступен' },
          { value: 1, text: 'Недоступен' },
        ]
      },
      suggestion: {
        address: false
      },
      search: {
        client: {
          loading: false,
          text: ''
        },
      },
    }),
    computed: {
      title: {
        get: function () {
          if (this.create) return 'Создание'
          if (this.change) return 'Изменение'
          if (this.view) return 'Просмотр'
          return ''
        },
      },
    },
    watch: {
      show: function () {
        if (this.show) {
          if (this.change) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }

          if (this.view) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }
          if (this.create) {
            this.form = {

            }
          }
        }
      },
    },
    mounted: function () {
      if (this.create) {
        this.form.created = moment().format('YYYY-MM-DD')
      }
      for (const x in this.$store.state.dict.device_type) {
        this.select.type.push({
          value: Number(x),
          text: this.$store.state.dict.device_type[x].name
        })
        this.dict.type[Number(x)] = this.$store.state.dict.device_type[x].name
      }
      var id = null
      if (this.item && this.item.id) id = this.item.id
      else
        if (this.$route.query.id && (this.view || this.change)) id = this.$route.query.id
      if (id) {
        this.axios.post('/api/device/list', { id: id })
          .then(result => {
            if (!result.data.error) {
              this.form = result.data.data[0]
              if (this.form.created) this.form.created = moment(this.form.created).format('YYYY-MM-DD')
              this.form.schedule = this.form.schedule || {}
              this.form.settings = this.form.settings || []
              this.form.planogramm = this.form.planogramm || []
              this.form.planogramm.push({ new: true })
              this.form.files = this.form.files || []
              this.form.settings.push({
                 new: true,
                type: 0,
                values: []
              })
              if (this.form.client) {
                this.load_clients_id(this.form.client)
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    methods: {
      planogramm_change: function (item) {
        if (item.new) {
          item.new = false
          this.form.planogramm.push({
            new: true
          })
        }
      },
      upload: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          const data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                for (const x in response.data.data) {
                  this.form.files.push(response.data.data[x])
                }

                console.log(this.form.files)
              }
              this.loader.show = false
            })
            .catch(error => {
              console.log(error)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      settings_change: function (item) {
        console.log(item)
        if (item.new) {
          item.new = false
          this.form.settings.push({
            new: true,
            type: 0,
            values: []
          })
        }
      },
      get_color: function (item, type) {
        return 'white'
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      getDoc: function (item) {
        console.log(item)
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file/get',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      open_file: function (id, item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: id,
            name: 'id',
          })
        )
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item,
            name: 'name',
          })
        )
        form.appendTo('body').submit()
      },
      adress_input: function (item) {
        if (!this.suggestion.address) {
          console.log('[name=address]')
          this.suggestion.address = true
          $('[name=address]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              this.form.address = data.unrestricted_value
              this.form.address_data = data.data
            },
          })
        }
      },
      save_device: function () {
        let url = '/api/device/create'
        if (this.form.id) { url = '/api/device/save' }
        this.form.settings = this.form.settings.filter(a => !a.new || a.new == false)
        this.form.planogramm = this.form.planogramm.filter(a => !a.new || a.new == false)
          this.axios.post(url, this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                this.$router.go(-1)
              } else {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            })
      },
    },
  }
</script>
